import { render } from "./CommunityPreview.vue?vue&type=template&id=49612e02&scoped=true"
const script = {}

import "./CommunityPreview.vue?vue&type=style&index=0&id=49612e02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49612e02"]])

export default __exports__